import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
    },
    // title: {
    //   display: true,
    //   text: "Data",
    // },
  },
  scales: {
    x: { grid: { display: false } },
    y: {
      grid: { display: false },
      border: { display: false },
      min: 0,
      ticks: { stepSize: 1 },
    },
  },
};

const labels = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const colors = [
  "rgba(255, 99, 132, 0.5)",
  "rgba(54, 162, 235, 0.5)",
  "rgba(255, 206, 86, 0.5)",
];

export function ChartBar({ data }) {
  if (!data || data.length === 0) return null;

  const datasets =
    data?.map((d, i) => ({
      label: d.title,
      data: d.dashboard_data?.map((dd) => dd.total) ?? [],
      backgroundColor: colors[i],
    })) ?? [];
  console.log("dataset", datasets);
  return <Bar options={options} data={{ labels, datasets }} />;
}
